import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ChangeEvent } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { invalidDecimalPointCharactersRegex } from '../../../../../../../utils/constants/regex';
import FieldWithErrors from '../../../../../../Forms/ReactHookForm/FieldWithErrors';

type Props = {
  isRedemptionFilledOut: boolean;
};

export function LetterAttributes({ isRedemptionFilledOut }: Props) {
  const { t } = useTranslation();

  const valueTooltipContent = t(
    'Only one of redemption or value can be present at a time.'
  );

  return (
    <>
      <FieldWithErrors name="vrednost" label={t('Value')} className="p-col-6">
        <div
          className="disabled-value-tooltip"
          data-pr-tooltip={valueTooltipContent}
        >
          <Controller
            name="vrednost"
            render={({ field }) => (
              <InputText
                id="vrednost"
                name="vrednost"
                value={field.value}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  field.onChange(
                    e.target.value?.replace(
                      invalidDecimalPointCharactersRegex,
                      ''
                    )
                  );
                }}
                disabled={isRedemptionFilledOut}
              />
            )}
          />
        </div>
      </FieldWithErrors>

      <FieldWithErrors
        name="letter_type_id"
        label={t('Letter type')}
        className="p-col-6"
      >
        <Controller
          name="letter_type_id"
          render={({ field }) => (
            <Dropdown
              id="letter_type_id"
              name="letter_type_id"
              options={[
                { value: 0, label: t('Regular') },
                { value: 1, label: t('Recommended') },
                { value: 1, label: t('Personal Delivery') },
              ]}
              value={field.value}
              onChange={field.onChange}
              placeholder={t('Select...')}
              showClear
              className="data-cy-letter_type_id"
            />
          )}
        />
      </FieldWithErrors>
    </>
  );
}
